<div class="audio-player d-flex flex-column align-items-center p-15" [class.playing]="isPlaying">
     <div class="d-flex w-100 gap-15 align-items-center">
      <div class="middle">
        <span class="title">{{data.title}}</span>
        <div class="waveform" #waveform></div>
      </div>
      <button class="play-button p-0" (click)="playPause()">
        <i class="{{ isPlaying ? 'ri-pause-line' : 'ri-play-fill' }}"></i>
      </button>
     </div>
    <div class="d-flex w-100 gap-5 align-items-center overflow-hidden">
      <div class="intensity">{{data.languageIntensity}}:</div>
      <div class="tags-container d-flex">
        <div class="tag">{{data.mainTag}}</div>
        <!-- <div class="tag" *ngFor="let tag of data.tags">{{tag}}</div> -->
      </div>
    </div>
</div>
  